import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { Dispatch } from "react";
import { Microservices } from "../../../../app/AllowedMicroservices";
import { RootState } from "../../../../app/store";
import apiActionCreator, {
  HttpMethods,
} from "../../../../services/apiActionCreator";
import { FetchStatus } from "../../../common/enums";
import { IEvaluationsCounters } from '../common/interfaces';


interface ISurveyResultsCountersState {
  data: IEvaluationsCounters[],
  status: FetchStatus,
}
const initialState: ISurveyResultsCountersState = {
  data: [],
  status: FetchStatus.Idle,
};

export const dataSlice = createSlice({
  name: "reportLearningCoursesSurveyResultsCounters",
  initialState,
  reducers: {
    fetching: (state) => {
      state.status = FetchStatus.Fetching;
    },
    fetched: (state, action: PayloadAction<IEvaluationsCounters[]>) => {
      state.data = action.payload;
      state.status = FetchStatus.Fetched;
    },
    error: (state) => {
      state.status = FetchStatus.Error;
    },
  },
});

export const { fetching, fetched, error } = dataSlice.actions;

interface IFetchSurveyCounters{
  companyId?: string,
  usersIds?: string[],
  parentId?: string
}
export const fetchSurveyCounters = ({ companyId, usersIds, parentId }:IFetchSurveyCounters) => (dispatch: Dispatch<object>) => {
  let url = '/evaluation/results/evaluationsCounters';
  const data:{
    evaluationType: string;
    companyId?: string,
    usersIds?: string[],
    parentId?: string,
  } = {
    companyId,
    usersIds,
    parentId,
    evaluationType: 'COURSE_SURVEY'
  };
  return dispatch(
    apiActionCreator({
      endpoint: url,
      types: {
        requestType: fetching,
        successTypes: [
          {
            actionOrCreator: fetched,
          },
        ],
        errorTypes: [
          {
            actionOrCreator: error,
          },
        ],
      },
      method: HttpMethods.POST,
      microservice: Microservices.EVALUATION_SERVICE,
      authenticated: true,
      data,
    })
  );
};

export const selectSurveyResultsCounters = (state: RootState) => state.reports.learning.courses.surveyResultsCounters.data;
export const selectSurveyResultsCountersIsFetching = (state: RootState) => state.reports.learning.courses.surveyResultsCounters.status === FetchStatus.Fetching;

export default dataSlice.reducer;
